import React, { useState } from 'react'
import {
  withStyles,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import shareData from './data'
import { SharePopover } from './components'

const CollectionShare = props => {
  const { classes } = props
  const [activeItem, setActiveItem] = useState('url')

  const handleChange = event => {
    setActiveItem(event.target.value)
  }

  return (
    <div className={classes.root}>
      {/* Mobile View */}
      <FormControl variant="outlined" className={classes.mobileSelect}>
        <InputLabel>Share Options</InputLabel>
        <Select
          value={activeItem}
          onChange={handleChange}
          label="Share Options"
          className={classes.select}
        >
          {shareData.map(item => (
            <MenuItem key={item.path} value={item.path}>
              <div className={classes.menuItem}>
                <Icon icon={item.icon} />
                <Typography>{item.label}</Typography>
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Desktop View */}
      <div className={classes.leftSideList}>
        {shareData.map(item => (
          <div
            key={item.path}
            className={`${classes.leftSideListItem} ${
              activeItem === item.path ? classes.active : ''
            }`}
            onClick={() => setActiveItem(item.path)}
          >
            <Icon
              icon={item.icon}
              style={{
                width: '18px',
                height: '18px',
              }}
            />
            <Typography fontWeight={400}>{item.label}</Typography>
          </div>
        ))}
      </div>
      <div className={classes.content}>
        <SharePopover activeItem={activeItem} />
      </div>
    </div>
  )
}

export default withStyles(styles)(CollectionShare)
